import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container-calendar" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = {
  key: 0,
  class: "flex-center w-full gap-04 font-size-14 mbottom-15"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "txt-warn" }
const _hoisted_8 = { class: "row w-full" }
const _hoisted_9 = { class: "col-0-12 colend mright-04" }
const _hoisted_10 = { class: "main-m font-m" }
const _hoisted_11 = {
  key: 0,
  class: "main-alert"
}
const _hoisted_12 = { class: "row-end w-full mtop-04" }
const _hoisted_13 = {
  key: 1,
  class: "es-patient-temp-form-div mtop-04"
}
const _hoisted_14 = { class: "row w-full" }
const _hoisted_15 = { class: "col-0-12 colend mright-04" }
const _hoisted_16 = { class: "main-m font-m" }
const _hoisted_17 = { class: "row w-full mtop-10" }
const _hoisted_18 = { class: "col-0-12 colend mright-04" }
const _hoisted_19 = { class: "main-m font-m" }
const _hoisted_20 = { class: "row w-full mtop-10" }
const _hoisted_21 = { class: "col-0-12 colend mright-04" }
const _hoisted_22 = { class: "main-m font-m" }
const _hoisted_23 = { class: "colend mleft-04 mright-04" }
const _hoisted_24 = { class: "main-m font-m" }
const _hoisted_25 = { class: "row w-full mtop-10" }
const _hoisted_26 = { class: "col-0-12 colend mright-04" }
const _hoisted_27 = { class: "main-m font-m" }
const _hoisted_28 = {
  key: 2,
  class: "row-top w-full mtop-10"
}
const _hoisted_29 = { class: "col-0-12 colend mright-04" }
const _hoisted_30 = { class: "main-m font-m" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "pleft-08 font-m" }
const _hoisted_33 = {
  key: 0,
  class: "pleft-08 font-m"
}
const _hoisted_34 = {
  key: 1,
  class: "pleft-08 font-m"
}
const _hoisted_35 = {
  key: 2,
  class: "pleft-08 font-m"
}
const _hoisted_36 = {
  key: 3,
  class: "row w-full mtop-10"
}
const _hoisted_37 = { class: "col-0-12 colend mright-04" }
const _hoisted_38 = { class: "main-m font-m" }
const _hoisted_39 = { key: 4 }
const _hoisted_40 = { class: "row w-full mtop-10" }
const _hoisted_41 = { class: "col-0-12 colend mright-04" }
const _hoisted_42 = { class: "main-m font-m" }
const _hoisted_43 = { class: "col-1-5 w-full pleft-08 font-m" }
const _hoisted_44 = {
  key: 5,
  class: "row w-full mtop-10"
}
const _hoisted_45 = { class: "col-0-12 colend mright-04" }
const _hoisted_46 = { class: "main-m font-m" }
const _hoisted_47 = {
  key: 6,
  class: "row w-full mtop-10"
}
const _hoisted_48 = { class: "col-0-12 colend mright-04" }
const _hoisted_49 = { class: "main-m font-m" }
const _hoisted_50 = {
  key: 7,
  class: "row w-full mtop-10"
}
const _hoisted_51 = { class: "col-0-4 mright-04 mleft-80" }
const _hoisted_52 = { class: "main-m font-m" }
const _hoisted_53 = { class: "col-0-10 mright-08" }
const _hoisted_54 = { class: "col-0-4 mright-04 mleft-04" }
const _hoisted_55 = { class: "main-m font-m" }
const _hoisted_56 = { class: "col-0-16" }
const _hoisted_57 = { key: 8 }
const _hoisted_58 = { class: "row w-full mtop-10" }
const _hoisted_59 = { class: "col-0-4 mright-04 mleft-50 colend" }
const _hoisted_60 = { class: "main-m font-m" }
const _hoisted_61 = { class: "col-0-10 mright-08" }
const _hoisted_62 = { class: "col-1-5 w-full pleft-08 font-m" }
const _hoisted_63 = { class: "col-0-4 mright-04 mleft-04 colend" }
const _hoisted_64 = { class: "main-m font-m" }
const _hoisted_65 = { class: "col-0-16" }
const _hoisted_66 = { class: "col-1-5 w-full pleft-08 font-m" }
const _hoisted_67 = {
  key: 9,
  class: "row w-full mtop-10"
}
const _hoisted_68 = { class: "col-0-12 colend mright-04" }
const _hoisted_69 = { class: "main-m font-m" }
const _hoisted_70 = {
  key: 10,
  class: "row-end w-full mtop-10"
}
const _hoisted_71 = { class: "txt-warn font-m" }
const _hoisted_72 = { class: "row w-full mtop-10" }
const _hoisted_73 = { class: "col-0-12 colend mright-04" }
const _hoisted_74 = { class: "main-m font-m" }
const _hoisted_75 = {
  key: 11,
  class: "row-end"
}
const _hoisted_76 = { class: "txt-red font-s" }
const _hoisted_77 = { key: 12 }
const _hoisted_78 = {
  key: 0,
  class: "row mtop-10 w-full"
}
const _hoisted_79 = { class: "col-0-12 colend mright-04" }
const _hoisted_80 = { class: "main-m font-m" }
const _hoisted_81 = {
  key: 0,
  class: "col-1-5 w-full font-m"
}
const _hoisted_82 = {
  key: 1,
  class: "col-1-5 w-full font-m"
}
const _hoisted_83 = {
  key: 1,
  class: "row mtop-10 w-full"
}
const _hoisted_84 = {
  key: 2,
  class: "row mtop-04 w-full"
}
const _hoisted_85 = { class: "col-0-12 colend mright-04" }
const _hoisted_86 = { class: "main-m font-m" }
const _hoisted_87 = ["src"]
const _hoisted_88 = {
  key: 3,
  class: "row mtop-10 w-full"
}
const _hoisted_89 = { class: "col-0-12 colend mright-04" }
const _hoisted_90 = { class: "main-m font-m" }
const _hoisted_91 = { class: "col-1-5 w-full font-m" }
const _hoisted_92 = {
  key: 4,
  class: "row mtop-10 w-full"
}
const _hoisted_93 = { class: "col-0-12 colend mright-04" }
const _hoisted_94 = { class: "main-m font-m" }
const _hoisted_95 = { class: "col-1-5 w-full font-m" }

import { ref, computed, watch, onMounted, watchEffect } from "vue";
import { useI18n } from 'vue-i18n';
import { addMinutes, format, formatISO, isToday, parse, parseISO } from "date-fns";
import { AppointmentRequest, AppointmentTypeApi, AppointmentTypeResponse, CheckAppointmentDurationResponse, PatientLightResponse, PhoneNumber, PlanningApi, UpdateAppointmentLocation } from '@/apiGenerate/medserver';
import { medServerApiConfig } from "@/config/medserver-api.config";
import { useAppUserStore } from "@/stores/appUser";
import { DateFormat, ItemButtonGroup, ItemSelect, ItemSelectPatient, ItemSelectPhone, ItemTag, MIDNIGHT_TIME, MIDNIGHT_TIME_CALENDAR, PatientStatus } from "@/models/share.model";
import Textarea from 'primevue/textarea';
import { PInputNumber } from "@/config/primevue";
import SharedService from "@/services/SharedService";
import EsWaitingRoomSelector from "@/components/EsWaitingRoomSelector.vue";
import SelectButton from 'primevue/selectbutton';
import { formatUTCDateTimeToTime, timeToUtcOffsetTimeWithDate, formatUTCDateTimeToDate } from '@/utils/date-utils';
import Select from 'primevue/select';
import { useDebounceFn } from "@vueuse/core";
import SearchPatientService from "@/services/SearchPatientService";
import { PHONE_PREFIX_LIST } from "@/functions/geo";
import EsSelectCountry from '@/components/esSelectCountry.vue';
import InputText from 'primevue/inputtext';
import Checkbox from 'primevue/checkbox';
import { getFlagEmojiForPrefix } from '@/functions/geo';
import { useCurrentEntryStore } from "@/stores/currentEntry";
import { appointment_duration_max, appointment_duration_min } from "@/models/calendar.model";
import DateService from "@/services/DateService";


export default /*@__PURE__*/_defineComponent({
  __name: 'esCalendarForm',
  props: {
    isOpen: { type: Boolean },
    isAllDayEvent: { type: Boolean },
    header: {},
    displayDelete: { type: Boolean },
    selectedDate: {},
    doctors: {},
    selectedDoctor: {},
    selectedAppointmentType: {},
    patient: {},
    deleteMethod: { type: Function },
    displayMoveButton: { type: Boolean },
    confirmMethod: { type: Function }
  },
  emits: ["modal-close", "delete-appointment", "move-appointment"],
  setup(__props: any, { emit: __emit }) {

const props = 
    __props;

const emits = __emit;

const { t } = useI18n();
const currentEntryStore = useCurrentEntryStore();

const appointmentTypeList = ref<AppointmentTypeResponse[]>([]);
const filteredAppointmentTypes = ref<ItemTag[]>([]);
const currentAppointmentType = ref<ItemTag>(props.selectedAppointmentType);

const patientLightList = ref<PatientLightResponse[]>([]);
const filteredPatients = ref<ItemSelect[]>([]);
const selectedPatient = ref<ItemSelect>(undefined);
const selectedPatientData = ref<PatientLightResponse>(undefined);

const filteredDoctors = ref<ItemTag[]>(props.doctors);
const currentDoctor = ref<ItemTag>(props.selectedDoctor);
const phoneCountries = ref<ItemSelectPhone[]>([]);

const textAreaRef = ref();
const warningMessage = ref<string | undefined>(undefined);
const isDateHoursInEdition = ref<boolean>(false);
const displayPatientTempForm = ref<boolean>(false);
const failedToFetchPortalPatientData = ref<boolean>(false);

const appointmentTypeApi = new AppointmentTypeApi(medServerApiConfig);
const planningApi = new PlanningApi(medServerApiConfig);
const appUserStore = useAppUserStore();

const getIsMoveAppointmentAction = computed (() => { return currentEntryStore.isMoveAppointmentAction; });

const getCurrentEvent = computed (() => { return currentEntryStore.currentEvent; });

const currInstituteUuid = computed(() => {
  if (!appUserStore.currentHealthGroupMembership) {return "";}
  const currentIwr = appUserStore.currentHealthGroupMembership.instituteWithRole;
  return currentIwr.instituteWithRoleId;
});

const healthGroupMembershipsUuid = computed(() => {
  if (!appUserStore.currentAppUserData) {return []}
  return appUserStore.currentAppUserData.healthGroupMemberships.map((healthGroupMemberships: any) => healthGroupMemberships.instituteWithRole?.instituteWithRoleId);
});

const appointmentRequest = ref<AppointmentRequest>({
  date: undefined,
  time: undefined,
  appointmentTypeId: undefined,
  patientId: undefined,
  doctorId: undefined,
  comment: undefined,
  location: undefined,
  departureTime: undefined,
  duration: undefined,
  portalUserUuid: undefined,
  isPatientWithoutAppointment: props.isAllDayEvent
});

const patientStatus = ref([
    {
      optionValue: PatientStatus.WAITING,
      optionLabel: t('common.patientStatus.' + PatientStatus.WAITING),
      icon: 'hourglass_2_fill',
      index: 0
    },
    {
      optionValue: PatientStatus.OUT,
      optionLabel: t('common.patientStatus.' + PatientStatus.OUT),
      icon: 'empty-set',
      index: 1
    },
    {
      optionValue: PatientStatus.LEAVE,
      optionLabel: t('common.patientStatus.' + PatientStatus.LEAVE),
      icon: 'checkmark-square',
      index: 2
    }
  ]);
const currentPatientStatus = ref({
      optionValue: PatientStatus.WAITING,
      optionLabel: t('common.patientStatus.' + PatientStatus.WAITING),
      icon: 'hourglass_2_fill',
      index: 0
    });

const getIconCreatePersonButton = computed ((): ItemButtonGroup => {
  return {
    codeAction: 'es-button-create-person',
    icon: 'person-plus_fill',
    pathIcon: 'shareIcons'
  };
});

const getIconCancelButton = computed ((): ItemButtonGroup => {
  return {
    codeAction: 'es-button-cancel',
    icon: 'xmark',
    pathIcon: 'shareIcons'
  };
});

const confirmFormModal = async () => {
  const date = appointmentRequest.value.isPatientWithoutAppointment ? format(new Date(), DateFormat.ISO_SMALL) : appointmentRequest.value.date;
  const time = appointmentRequest.value.isPatientWithoutAppointment || !appointmentRequest.value.time || (appointmentRequest.value.time === MIDNIGHT_TIME_CALENDAR)
    ? MIDNIGHT_TIME 
    : appointmentRequest.value.time;
  
  warningMessage.value = undefined;
    
  appointmentRequest.value.date = date;
  appointmentRequest.value.time = DateService.formatTimeWithTimezone(date, time.substring(0, 5));

  try {
    await props.confirmMethod(appointmentRequest.value);
  } catch {
    throw t('error.DEFAULT');
  }
}

const phoneCountryToItemSelect = (phone: {prefix: string, isoCode: string; term: string}): ItemSelectPhone => {
  return {
    id: phone.isoCode,
    label: `${phone.term}`, 
    prefix: `+${phone.prefix}` 
  }
}

const getPhoneCountries = () => {
  phoneCountries.value = PHONE_PREFIX_LIST.map((phone: {prefix: string, isoCode: string; term: string}) => {
    return phoneCountryToItemSelect(phone);
  });
}

const getSelectedCountry = (value: string): ItemSelect => {
  const phoneCountriesFiltered = phoneCountries.value.filter((phoneCountry) => phoneCountry.prefix === `+${value}`);
  return {
    id: phoneCountriesFiltered?.length > 0 ? phoneCountriesFiltered[0].id : undefined,
    label: phoneCountriesFiltered?.length > 0 ? phoneCountriesFiltered[0].prefix : undefined,
  }
}

const setPhonePrefix = (phonePrefix: string) => {
  if (phonePrefix) {
    const phoneCountriesFiltered = phoneCountries.value.filter((phoneCountry) => phoneCountry.id === phonePrefix);
    appointmentRequest.value.personAppointment.phoneNumber.phonePrefix = phoneCountriesFiltered?.length > 0 ? phoneCountriesFiltered[0].prefix.replace('+', '') : undefined;
  } else {
    appointmentRequest.value.personAppointment.phoneNumber.phonePrefix = undefined;
  }
}

const closeFormModal = () => {
  warningMessage.value = undefined;
  selectedPatientData.value = undefined;
  emits('modal-close');
}

const deleteFormModal = async() => {
  warningMessage.value = undefined;
  try {
    await props.deleteMethod(appointmentRequest.value);
  } catch {
    throw t('error.DEFAULT');
  }
}

const checkAppointmentDuration = async () => {
  if (currInstituteUuid.value && appointmentRequest.value.duration && appointmentRequest.value.time) {
    planningApi.checkAppointmentDuration(
    {instituteId: currInstituteUuid.value,
      date: appointmentRequest.value.date,
      time: timeToUtcOffsetTimeWithDate(format(parseISO(appointmentRequest.value.date + "T" + appointmentRequest.value.time), DateFormat.TIME_LONG), new Date(appointmentRequest.value.date)),
      doctorId: appointmentRequest.value.doctorId,
      appointmentTypeId: appointmentRequest.value.appointmentTypeId,
      duration: appointmentRequest.value.duration
    }).then((res: CheckAppointmentDurationResponse) => {
      if (res.warningCode) {
          warningMessage.value = t(`warn.${res.warningCode}`);
      } else {
        warningMessage.value = '';
      }
    });
  }
}

const appointmentTypeResponseToItemTag = (appointmentTypeResponse: AppointmentTypeResponse): ItemTag => {
return {
    id: appointmentTypeResponse.appointmentTypeId,
    label: appointmentTypeResponse.name,
    opened: false,
    selected: false
  }
}

const getAllAppointmentTypes = async () => {
  if (currInstituteUuid.value && (appointmentRequest.value.doctorId || currentDoctor.value?.id )) {
    await appointmentTypeApi.listAppointmentTypes({instituteId: currInstituteUuid.value, doctorId: appointmentRequest.value.doctorId ?? currentDoctor.value.id ?? undefined, isSetting: false}).then((response: AppointmentTypeResponse[]) => {
      appointmentTypeList.value = response;

      filteredAppointmentTypes.value = appointmentTypeList.value.map((appointmentType: AppointmentTypeResponse) => appointmentTypeResponseToItemTag(appointmentType));

      if (currentAppointmentType.value) {
         filteredAppointmentTypes.value = appointmentTypeList.value.filter((appointmentType) => {
                return appointmentType.name.toLowerCase().includes(currentAppointmentType.value.label.toLowerCase())
            }).map(appointmentType => appointmentTypeResponseToItemTag(appointmentType));
      }
    });
  }
}

const setAppointmentLocation = async (location: UpdateAppointmentLocation) => {
    if (!appointmentRequest.value.departureTime) {
      appointmentRequest.value.location = location;

      if (location.customRoomName || location.roomId) {
        currentPatientStatus.value = {
          optionValue: PatientStatus.WAITING,
          optionLabel: t('common.patientStatus.' + PatientStatus.WAITING),
          icon: 'hourglass_2_fill',
          index: 0
        };
      }
    }
    
}

const updateAppointmentDate = async (newAppointmentDate: string) => {
  if (newAppointmentDate && getCurrentEvent.value) {
    appointmentRequest.value.date = format(new Date(newAppointmentDate), DateFormat.ISO_SMALL);
    await checkAppointmentDuration();
  }
}

const updateAppointmentTime = async (newAppointmentTime: string) => {
  if (newAppointmentTime && getCurrentEvent.value) {
    if (format(new Date(newAppointmentTime), DateFormat.TIME_LONG) !==  getCurrentEvent.value.extendedProps.appointmentTime) {
      appointmentRequest.value.time = format(new Date(newAppointmentTime), DateFormat.TIME_LONG);
    }

    await checkAppointmentDuration();
  }
}

const getDateValue = () => {
  return new Date(appointmentRequest.value.date);
}

const getTimeValue = (): Date => {
  if (appointmentRequest.value.date != format(new Date(getCurrentEvent.value.start.toString()), DateFormat.ISO_SMALL)) {
    return new Date(format(new Date(getCurrentEvent.value.start.toString()), DateFormat.ISO_SMALL) + "T" + appointmentRequest.value.time);
  }

  return new Date(appointmentRequest.value.date + "T" + appointmentRequest.value.time);
}

const debouncedSearchPatient = useDebounceFn((event: string) => {
  if (event) {
    searchPatient(event);
  } else {
    appointmentRequest.value.patientId = undefined;
    if (appointmentRequest.value.personAppointment?.personAppointmentId) {
      displayPatientTempForm.value = true;
    }
  }  
}, 500);

const searchPatient = (event: string) => {
  setTimeout(async() => {
    if (event && typeof event === 'string') {
      SearchPatientService.searchPatient(event.toLowerCase(), healthGroupMembershipsUuid.value).then((res) => 
      filteredPatients.value = res);
    }
  }, 500);
};


const searchDoctor = (event: string | ItemTag) => {
    setTimeout(() => { 
      if (!event) {
        filteredDoctors.value = props.doctors;
      } else {
        let searchValue: string = typeof event === 'object' ? event.label : event;

        if (!searchValue.trim().length) {
            filteredDoctors.value = props.doctors;
        } else {
            filteredDoctors.value = props.doctors.filter((doctor) => {
                return doctor.label.toLowerCase().includes(searchValue.toLowerCase())
            });
        }
      }
    }, 250);
}

const isAllDayEventFormValid = (): boolean => {
  return (appointmentRequest.value.patientId || (appointmentRequest.value.personAppointment?.firstname && appointmentRequest.value.personAppointment?.lastname))
    && (!appointmentRequest.value.comment || appointmentRequest.value.comment.length < 256);
}

const isEventFormValid = (): boolean => {
  return !isDateHoursInEdition.value && appointmentRequest.value.appointmentTypeId 
            && appointmentRequest.value.doctorId
            && (appointmentRequest.value.patientId || (displayPatientTempForm.value && appointmentRequest.value.personAppointment?.firstname && appointmentRequest.value.personAppointment?.lastname) || appointmentRequest.value.portalUserUuid)
            && appointmentRequest.value.date
            && appointmentRequest.value.time
            && appointmentRequest.value.duration
            && (!appointmentRequest.value.comment || appointmentRequest.value.comment.length < 256);
}

const validForm = () => {
  return props.isAllDayEvent
    ? isAllDayEventFormValid()
    : isEventFormValid();
}

const setDisplayPatientTempForm = (display: boolean) => {
  if ((appointmentRequest.value.portalUserUuid || getCurrentEvent.value?.extendedProps.portalUserUuid) && !getCurrentEvent.value?.extendedProps?.personAppointment) {
    if (display) {
      appointmentRequest.value.personAppointment = {
        personAppointmentId: undefined,
        lastname: getCurrentEvent.value.extendedProps?.portalUser?.lastname ?? undefined,
        firstname: getCurrentEvent.value.extendedProps?.portalUser?.firstname ?? undefined,
        email: getCurrentEvent.value.extendedProps?.portalUser?.email ?? undefined,
        phoneNumber: getCurrentEvent.value.extendedProps?.portalUser?.phoneNumber ?? {
          phoneNumber: undefined,
          phonePrefix: undefined,
          mobile: undefined
        }
      }
    } else {
      appointmentRequest.value.personAppointment = undefined;
    }   
  } else {
    appointmentRequest.value.personAppointment = {
      personAppointmentId: undefined,
      lastname:  undefined,
      firstname: undefined,
      email: undefined,
      phoneNumber: {
        phoneNumber: undefined,
        phonePrefix: undefined,
        mobile: undefined
      }
    };
  }
  displayPatientTempForm.value = display;
}

const getFormattedPhone = (phone: PhoneNumber) => {
  return getFlagEmojiForPrefix(phone.phonePrefix) + ' +' + PHONE_PREFIX_LIST.find(item => item.prefix === phone.phonePrefix).prefix + ' ' + phone.phoneNumber.match(/.{1,3}/g).join(' ')
}

const moveAppointment = async () => {
  await currentEntryStore.setMoveAppointmentFromCalendar(appointmentRequest.value);
  if(appointmentRequest.value.portalUserUuid) {
    if(selectedPatientData.value && selectedPatientData.value.patientId) {
     emits('move-appointment', {doctorId : appointmentRequest.value.doctorId, selectedPatient: selectedPatientData.value, selectedType: currentAppointmentType.value, 
      appointment: getCurrentEvent.value});
    } else {
      emits('move-appointment', {doctorId : appointmentRequest.value.doctorId, selectedPatient: {
        firstname : getCurrentEvent.value.extendedProps?.portalUser?.firstname, 
        lastname : getCurrentEvent.value.extendedProps?.portalUser?.lastname }, 
        selectedType: currentAppointmentType.value, 
        appointment: getCurrentEvent.value
      });
    }
  } else {
    if (getCurrentEvent.value.extendedProps?.personAppointment) {
      emits('move-appointment', {doctorId : appointmentRequest.value.doctorId, selectedPatient: {
        firstname : getCurrentEvent.value.extendedProps.personAppointment.firstname,
        lastname : getCurrentEvent.value.extendedProps.personAppointment.lastname },
        selectedType: currentAppointmentType.value,
        appointment: getCurrentEvent.value
      });
    } else {
      emits('move-appointment', {doctorId : appointmentRequest.value.doctorId, selectedPatient: selectedPatientData.value, selectedType: currentAppointmentType.value,
        appointment: getCurrentEvent.value});
    }
  }
}

const onAppointmentTypeChange = (event: string | ItemTag) => {
  let searchValue: string | undefined;
  if (typeof event === 'object') {
    currentAppointmentType.value = event;
    searchValue = event.label;
  } else {
    searchValue = event;
  }

  let filteredValues: ItemTag[] = [];
  if (!searchValue || !searchValue.trim()) {
    filteredValues = appointmentTypeList.value.map((appoitnmentType) => appointmentTypeResponseToItemTag(appoitnmentType));
  } else {
    searchValue = searchValue.toLocaleLowerCase();
    filteredValues = appointmentTypeList.value
      .filter((appoitnmentType) => appoitnmentType.name.toLowerCase().includes(searchValue))
      .map((appoitnmentType) => appointmentTypeResponseToItemTag(appoitnmentType));
  }

  filteredAppointmentTypes.value = filteredValues;
}

const searchForPortalPatientCns = async (cns: string) => {
  if (cns) {
    const res = await SearchPatientService.searchPatient(cns, healthGroupMembershipsUuid.value);
    if (res && res.length > 0) {
      selectedPatient.value = res[0];
    } else {
      selectedPatient.value = undefined;
    }

    filteredPatients.value = res;
  }
}

watch(
  () => currentPatientStatus.value,
  () => {
    if (currentPatientStatus.value?.optionValue === PatientStatus.LEAVE) {
      appointmentRequest.value.departureTime = format(new Date(), DateFormat.TIME_FR_LONG);
    } else {
      appointmentRequest.value.departureTime = undefined;

      if (currentPatientStatus.value?.optionValue === PatientStatus.OUT) {
        appointmentRequest.value.location = null;
      }
    } 
  }
)

watch(
  () => selectedPatient.value,
  () => {
    if (selectedPatient.value) {
      appointmentRequest.value.patientId = selectedPatient.value.id;
    } else {
      filteredPatients.value = [];
    }  
  }
)

watch(
  () => currentDoctor.value,
  () => {
    if (currentDoctor.value && currentDoctor.value.id !== appointmentRequest.value.doctorId) {
      appointmentRequest.value.doctorId = currentDoctor.value.id;
      currentAppointmentType.value = undefined;
      getAllAppointmentTypes();
    }
  }
)

watch(
  () => currentAppointmentType.value,
  () => {
    if (!currentAppointmentType.value) {
      appointmentRequest.value.duration = undefined;
    } else if (typeof currentAppointmentType.value === 'object' && (appointmentRequest.value.appointmentTypeId != currentAppointmentType.value.id || !appointmentRequest.value.duration)) {
      const appointmentTypeFiltered: AppointmentTypeResponse[] =  appointmentTypeList.value.filter((appointmentType: AppointmentTypeResponse) => appointmentType.appointmentTypeId === currentAppointmentType.value.id);
      if (appointmentTypeFiltered) {
        appointmentRequest.value.duration = appointmentTypeFiltered[0].durationMin;
        filteredAppointmentTypes.value = appointmentTypeFiltered.map((appointmentType: AppointmentTypeResponse) => appointmentTypeResponseToItemTag(appointmentType));
        currentAppointmentType.value = filteredAppointmentTypes.value[0];
        appointmentRequest.value.appointmentTypeId = filteredAppointmentTypes.value[0].id;
      } 
    }
  }
)

watch(
  () => appointmentRequest.value.duration,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      checkAppointmentDuration();
    }
  }
);

watch(
  () => props.selectedAppointmentType,
  () => {
    if (props.selectedAppointmentType) {
      const appointmentTypeFiltered: AppointmentTypeResponse[] =  appointmentTypeList.value.filter((appointmentType: AppointmentTypeResponse) => appointmentType.appointmentTypeId === props.selectedAppointmentType.id);
      if (appointmentTypeFiltered) {
        filteredAppointmentTypes.value = appointmentTypeFiltered.map((appointmentType: AppointmentTypeResponse) => appointmentTypeResponseToItemTag(appointmentType));
        currentAppointmentType.value = filteredAppointmentTypes.value[0];
      }
    }
  }
)

watchEffect(() => {
  appointmentRequest.value.isPatientWithoutAppointment = props.isAllDayEvent
})

watch(
    () => props.isOpen,
  async () => {
    if (props.isOpen === true) {
      if (props.selectedDoctor) {
        filteredDoctors.value = props.doctors.filter((doctor) => {
          return doctor.label.toLowerCase().includes(props.selectedDoctor.label.toLowerCase())
        });

        currentDoctor.value = filteredDoctors.value[0];
      } else {
        filteredDoctors.value = props.doctors;
        currentDoctor.value = undefined;
      }

      failedToFetchPortalPatientData.value = false;
      displayPatientTempForm.value = false;

      // init patient list
      patientLightList.value = [];
      selectedPatient.value = undefined;

      if (currInstituteUuid.value) {
          await getAllAppointmentTypes();

          if (getCurrentEvent.value) {
            failedToFetchPortalPatientData.value = !!getCurrentEvent.value.extendedProps.failedToFetchPortalPatientData;
            appointmentRequest.value = {
              date: getIsMoveAppointmentAction.value ? format(props.selectedDate, DateFormat.ISO_SMALL) : format(new Date(getCurrentEvent.value.start.toString()), DateFormat.ISO_SMALL) ,
              time: getIsMoveAppointmentAction.value ? format(props.selectedDate, DateFormat.TIME_FR_LONG) :  getCurrentEvent.value.extendedProps.appointmentTime,
              duration: getCurrentEvent.value.extendedProps.duration,
              appointmentTypeId: getCurrentEvent.value.extendedProps.appointmentTypeId ?? undefined,
              patientId: getCurrentEvent.value.extendedProps.patientId ?? undefined,
              doctorId: props.selectedDoctor?.id ?? undefined,
              comment: getCurrentEvent.value.extendedProps.comment ?? undefined,
              departureTime:getCurrentEvent.value.extendedProps.departureTime ?? undefined,
              location: getCurrentEvent.value.extendedProps.waitingRoom ? {
                customRoomName: getCurrentEvent.value.extendedProps.waitingRoom
              }  : undefined,
              portalUserUuid: getCurrentEvent.value.extendedProps.portalUserUuid
            };

            if (getCurrentEvent.value.extendedProps?.patientId) {
              patientLightList.value.push({
                patientId: getCurrentEvent.value.extendedProps.patientId,
                firstname: getCurrentEvent.value.extendedProps.firstname,
                lastname: getCurrentEvent.value.extendedProps.lastname,
                birthdate: getCurrentEvent.value.extendedProps.birthdate,
                serialNumber: undefined,
              });
            }

            if (getCurrentEvent.value.extendedProps?.personAppointment) {
              appointmentRequest.value.personAppointment = {
                personAppointmentId: getCurrentEvent.value.extendedProps?.personAppointment.personAppointmentId,
                lastname: getCurrentEvent.value.extendedProps?.personAppointment.lastname,
                firstname: getCurrentEvent.value.extendedProps?.personAppointment.firstname,
                email: getCurrentEvent.value.extendedProps?.personAppointment.email,
                phoneNumber: getCurrentEvent.value.extendedProps?.personAppointment.phoneNumber ?? {
                  phoneNumber: undefined,
                  phonePrefix: undefined,
                  mobile: undefined
                }
              }
              displayPatientTempForm.value = getCurrentEvent.value.extendedProps?.personAppointment.personAppointmentId != null;
            }

            const patientFiltered = patientLightList.value.filter((patient: PatientLightResponse) => patient.patientId === appointmentRequest.value.patientId);
            if (patientFiltered && patientFiltered.length > 0) {
              selectedPatientData.value = patientFiltered[0];
              filteredPatients.value = patientFiltered.map(patientLightResponse => SearchPatientService.patientLightResponseToItemSelect(patientLightResponse));
              selectedPatient.value = filteredPatients.value[0];
            } else if (getCurrentEvent.value.extendedProps.portalUser?.nationalIdentityNumber) {
              selectedPatient.value = {
                id: undefined,
                label: getCurrentEvent.value.extendedProps.portalUser?.nationalIdentityNumber
              }

              filteredPatients.value[0] = selectedPatient.value;
          }

            if (appointmentRequest.value.appointmentTypeId) {
              const appointmentTypeFiltered =  appointmentTypeList.value.filter((appointmentType: AppointmentTypeResponse) => appointmentType.appointmentTypeId === appointmentRequest.value.appointmentTypeId);
              if (appointmentTypeFiltered) {
                filteredAppointmentTypes.value = appointmentTypeFiltered.map((appointmentType) => appointmentTypeResponseToItemTag(appointmentType));
                currentAppointmentType.value = filteredAppointmentTypes.value[0];
              }
            }
            if (appointmentRequest.value.departureTime) {
              currentPatientStatus.value = {
                optionValue: PatientStatus.LEAVE,
                optionLabel: t('common.patientStatus.' + PatientStatus.LEAVE),
                icon: 'checkmark-square',
                index: 2
              };
            } else if (!appointmentRequest.value.location && getCurrentEvent.value.extendedProps.arrivalTime) {
              currentPatientStatus.value = {
                optionValue: PatientStatus.OUT,
                optionLabel: t('common.patientStatus.' + PatientStatus.OUT),
                icon: 'empty-set',
                index: 1
              };
            }
          } else {
            currentPatientStatus.value = {
              optionValue: PatientStatus.WAITING,
              optionLabel: t('common.patientStatus.' + PatientStatus.WAITING),
              icon: 'hourglass_2_fill',
              index: 0
            };

            appointmentRequest.value = {
              date: format(props.selectedDate, DateFormat.ISO_SMALL),
              time: props.isAllDayEvent? MIDNIGHT_TIME_CALENDAR : format(props.selectedDate, DateFormat.TIME_FR_LONG),
              appointmentTypeId: props.selectedAppointmentType ? props.selectedAppointmentType.id : undefined,
              patientId: props.patient ? props.patient.id : undefined,
              comment: undefined,
              doctorId: props.selectedDoctor ? props.selectedDoctor.id : undefined,
              duration: currentEntryStore.moveAppointmentFromCalendar ? currentEntryStore.moveAppointmentFromCalendar.duration : undefined,
              departureTime: undefined,
              location: undefined,
              personAppointment: {
                personAppointmentId: undefined,
                firstname: undefined,
                lastname: undefined,
                email: undefined,
                phoneNumber: {
                  phoneNumber: undefined,
                  phonePrefix: undefined,
                  mobile: undefined
                }
              }
            };
            if (props.patient) {
              if(patientLightList.value.length === 0){
                patientLightList.value.push({
                  patientId: props.patient.id,
                  firstname: props.patient.label?.split(" ")[0] ?? "",
                  lastname: props.patient.label?.split(" ")[1] ?? "",
                  birthdate: props.patient.birthdate,
                  serialNumber: props.patient.serialNumber,
                });
              }
              const patientFiltered = patientLightList.value.filter((patient: PatientLightResponse) => patient.patientId === props.patient.id);
              if (patientFiltered && patientFiltered.length > 0) {
                filteredPatients.value = patientFiltered.map(patientLightResponse => SearchPatientService.patientLightResponseToItemSelect(patientLightResponse));
                selectedPatient.value = patientFiltered.map(patientLightResponse => SearchPatientService.patientLightResponseToItemSelect(patientLightResponse))[0];
              }
            } else {
              filteredPatients.value = patientLightList.value.map(patientLightResponse => SearchPatientService.patientLightResponseToItemSelect(patientLightResponse));
              selectedPatient.value = undefined;
            }

            if (props.selectedAppointmentType) {
              const appointmentTypeFiltered =  appointmentTypeList.value.filter((appointmentType: AppointmentTypeResponse) => appointmentType.appointmentTypeId === appointmentRequest.value.appointmentTypeId);
              if (appointmentTypeFiltered) {
                filteredAppointmentTypes.value = appointmentTypeFiltered.map((appointmentType) => appointmentTypeResponseToItemTag(appointmentType));
                currentAppointmentType.value = filteredAppointmentTypes.value[0];
              }
            } else {
              filteredAppointmentTypes.value = appointmentTypeList.value.map((appointmentType) => appointmentTypeResponseToItemTag(appointmentType));
              currentAppointmentType.value = undefined;
            }
          }
          textAreaRef.value.$el.focus();
      } else {
        appointmentRequest.value = {
          date: format(props.selectedDate, DateFormat.ISO_SMALL),
          time: props.isAllDayEvent? MIDNIGHT_TIME_CALENDAR : format(props.selectedDate, DateFormat.TIME_FR_LONG),
          appointmentTypeId: props.selectedAppointmentType ? props.selectedAppointmentType.id : undefined,
          patientId: props.patient ? props.patient.id : undefined,
          comment: undefined,
          doctorId: props.selectedDoctor ? props.selectedDoctor.id : undefined,
          duration: undefined,
          departureTime: undefined,
          location: undefined,
          personAppointment: {
            personAppointmentId: undefined,
            firstname: undefined,
            lastname: undefined,
            email: undefined,
            phoneNumber: {
              phoneNumber: undefined,
              phonePrefix: undefined,
              mobile: undefined
            }
          }
        };

        textAreaRef.value.$el.focus();
      }
    }
  }
);

watch(currentAppointmentType, () => {
  warningMessage.value = '';
});

onMounted(() => {
  getPhoneCountries();
});

return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_button = _resolveComponent("es-button")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_es_modal_header, {
              header: _ctx.header,
              "display-confirm-delete-modale": true,
              displayDelete: _ctx.displayDelete,
              "label-delete": _unref(t)('calendar.label.delete.action'),
              "confirm-method": deleteFormModal,
              "label-button-action": _ctx.displayMoveButton ? 'calendar.label.move.action' : undefined,
              "icon-action": _ctx.displayMoveButton ? 'calendar-arrow-from' : undefined,
              "path-icon-action": 'shareIcons',
              onExecuteAction: _cache[0] || (_cache[0] = ($event: any) => (moveAppointment()))
            }, null, 8, ["header", "displayDelete", "label-delete", "label-button-action", "icon-action"]),
            _createElementVNode("div", _hoisted_4, [
              (failedToFetchPortalPatientData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: _unref(SharedService).getIcon('exclamationmark-triangle', true, 'shareIcons'),
                      class: "img-warn icon-container"
                    }, null, 8, _hoisted_6),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('calendar.label.add.form.portalError')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("label", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_unref(t)('calendar.label.add.form.patient')), 1),
                    (!displayPatientTempForm.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "*"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode(_unref(Select), {
                  modelValue: selectedPatient.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPatient).value = $event)),
                  options: filteredPatients.value,
                  optionLabel: "label",
                  size: "small",
                  showClear: "",
                  editable: "",
                  onBeforeShow: _cache[2] || (_cache[2] = ($event: any) => {searchForPortalPatientCns(getCurrentEvent.value?.extendedProps?.portalUser?.nationalIdentityNumber);}),
                  onValueChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(debouncedSearchPatient)($event))),
                  emptyMessage: _unref(t)('patient.search.noResult'),
                  class: "w-full",
                  disabled: displayPatientTempForm.value
                }, null, 8, ["modelValue", "options", "emptyMessage", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                (!displayPatientTempForm.value && !appointmentRequest.value.patientId)
                  ? (_openBlock(), _createBlock(_component_es_button, {
                      key: 0,
                      "icon-content-button": getIconCreatePersonButton.value,
                      label: _unref(t)('calendar.label.add.form.addPerson'),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (setDisplayPatientTempForm(true))),
                      "is-linked": true,
                      "is-primary": false,
                      styles: 'font-m txt-primary',
                      iconStyles: 'img-primary'
                    }, null, 8, ["icon-content-button", "label"]))
                  : _createCommentVNode("", true),
                (displayPatientTempForm.value && !appointmentRequest.value.patientId)
                  ? (_openBlock(), _createBlock(_component_es_button, {
                      key: 1,
                      "icon-content-button": getIconCancelButton.value,
                      label: _unref(t)('action.cancel'),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (setDisplayPatientTempForm(false))),
                      "is-linked": true,
                      "is-primary": false,
                      styles: 'font-m txt-primary',
                      iconStyles: 'img-primary'
                    }, null, 8, ["icon-content-button", "label"]))
                  : _createCommentVNode("", true)
              ]),
              (displayPatientTempForm.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, [
                          _createTextVNode(_toDisplayString(_unref(t)('calendar.label.add.form.lastname')), 1),
                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                        ])
                      ]),
                      _createVNode(_unref(InputText), {
                        modelValue: appointmentRequest.value.personAppointment.lastname,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((appointmentRequest.value.personAppointment.lastname) = $event)),
                        type: "text",
                        size: "small",
                        class: "w-full"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, [
                          _createTextVNode(_toDisplayString(_unref(t)('calendar.label.add.form.firstname')), 1),
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                        ])
                      ]),
                      _createVNode(_unref(InputText), {
                        modelValue: appointmentRequest.value.personAppointment.firstname,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((appointmentRequest.value.personAppointment.firstname) = $event)),
                        type: "text",
                        size: "small",
                        class: "w-full"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)('calendar.label.add.form.favoritePhone')), 1)
                      ]),
                      _createVNode(EsSelectCountry, {
                        selectedData: getSelectedCountry(appointmentRequest.value.personAppointment?.phoneNumber?.phonePrefix ?? undefined),
                        onChangeSelect: _cache[8] || (_cache[8] = ($event: any) => (setPhonePrefix($event))),
                        countries: phoneCountries.value,
                        "show-prefix": true,
                        default: false
                      }, null, 8, ["selectedData", "countries"]),
                      _createVNode(_unref(InputText), {
                        type: "text",
                        size: "small",
                        class: "w-full mleft-02",
                        modelValue: appointmentRequest.value.personAppointment.phoneNumber.phoneNumber,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((appointmentRequest.value.personAppointment.phoneNumber.phoneNumber) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('calendar.label.add.form.mobile')), 1)
                      ]),
                      _createVNode(_unref(Checkbox), {
                        binary: "",
                        modelValue: appointmentRequest.value.personAppointment.phoneNumber.mobile,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((appointmentRequest.value.personAppointment.phoneNumber.mobile) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(t)('calendar.label.add.form.mail')), 1)
                      ]),
                      _createVNode(_unref(InputText), {
                        type: "text",
                        size: "small",
                        class: "w-full",
                        modelValue: appointmentRequest.value.personAppointment.email,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((appointmentRequest.value.personAppointment.email) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (getCurrentEvent.value && appointmentRequest.value.portalUserUuid !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(t)('calendar.label.add.form.portalPatient')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, _toDisplayString(getCurrentEvent.value.extendedProps.portalUserName), 1),
                      (getCurrentEvent.value.extendedProps.portalUser?.nationalIdentityNumber)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_33, _toDisplayString(getCurrentEvent.value.extendedProps.portalUser.nationalIdentityNumber), 1))
                        : _createCommentVNode("", true),
                      (getCurrentEvent.value.extendedProps.portalUser?.email)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_34, _toDisplayString(getCurrentEvent.value.extendedProps.portalUser?.email), 1))
                        : _createCommentVNode("", true),
                      ( getCurrentEvent.value.extendedProps.portalUser?.phoneNumber)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_35, _toDisplayString(getFormattedPhone(getCurrentEvent.value.extendedProps.portalUser?.phoneNumber)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (getCurrentEvent.value || !currentDoctor.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(t)('calendar.label.add.form.healthPro')), 1)
                    ]),
                    _createVNode(_unref(Select), {
                      modelValue: currentDoctor.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((currentDoctor).value = $event)),
                      options: filteredDoctors.value,
                      optionLabel: "label",
                      size: "small",
                      showClear: "",
                      editable: "",
                      onValueChange: _cache[13] || (_cache[13] = ($event: any) => (searchDoctor($event))),
                      emptyMessage: _unref(t)('patient.search.noResult'),
                      class: "w-full"
                    }, null, 8, ["modelValue", "options", "emptyMessage"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("label", _hoisted_42, [
                          _createTextVNode(_toDisplayString(_unref(t)('calendar.label.add.form.healthPro')), 1),
                          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_43, _toDisplayString(currentDoctor.value.label), 1)
                    ])
                  ])),
              (!getIsMoveAppointmentAction.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, [
                        _createTextVNode(_toDisplayString(_unref(t)('calendar.label.add.form.appointmentType')), 1),
                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                      ])
                    ]),
                    _createVNode(_unref(Select), {
                      "model-value": currentAppointmentType.value,
                      options: filteredAppointmentTypes.value,
                      optionLabel: "label",
                      size: "small",
                      showClear: "",
                      editable: "",
                      "onUpdate:modelValue": onAppointmentTypeChange,
                      emptyMessage: _unref(t)('patient.search.noResult'),
                      class: "w-full"
                    }, null, 8, ["model-value", "options", "emptyMessage"])
                  ]))
                : _createCommentVNode("", true),
              (getCurrentEvent.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(t)('calendar.label.add.form.isPatientWithoutAppointment')), 1)
                    ]),
                    _createVNode(_unref(Checkbox), {
                      modelValue: appointmentRequest.value.isPatientWithoutAppointment,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((appointmentRequest.value.isPatientWithoutAppointment) = $event)),
                      binary: ""
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (getCurrentEvent.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("label", _hoisted_52, [
                        _createTextVNode(_toDisplayString(_unref(t)('calendar.label.add.form.date')), 1),
                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_esInputDateTime, {
                        dateTimeValue: getDateValue(),
                        dateFormat: _unref(DateFormat).DATEPICKER,
                        withTime: false,
                        isSetting: false,
                        selectOtherMonths: true,
                        disabled: appointmentRequest.value.isPatientWithoutAppointment,
                        onUpdateDateTime: _cache[15] || (_cache[15] = ($event: any) => (updateAppointmentDate($event))),
                        onIsDatePickerOpen: _cache[16] || (_cache[16] = ($event: any) => (isDateHoursInEdition.value = true)),
                        onIsDatePickerClose: _cache[17] || (_cache[17] = ($event: any) => (isDateHoursInEdition.value = false)),
                        size: "small"
                      }, null, 8, ["dateTimeValue", "dateFormat", "disabled"])
                    ]),
                    (!appointmentRequest.value.isPatientWithoutAppointment)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("label", _hoisted_55, [
                              _createTextVNode(_toDisplayString(_unref(t)('calendar.label.add.form.time')), 1),
                              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_component_esInputDateTime, {
                              disabled: currentAppointmentType.value?.id === undefined,
                              dateTimeValue: getTimeValue(),
                              dateFormat: _unref(DateFormat).TIME_FR_SMALL,
                              timeOnly: true,
                              isSetting: false,
                              onUpdateDateTime: _cache[18] || (_cache[18] = ($event: any) => (updateAppointmentTime($event))),
                              onIsDatePickerOpen: _cache[19] || (_cache[19] = ($event: any) => (isDateHoursInEdition.value = true)),
                              onIsDatePickerClose: _cache[20] || (_cache[20] = ($event: any) => (isDateHoursInEdition.value = false)),
                              size: "small"
                            }, null, 8, ["disabled", "dateTimeValue", "dateFormat"])
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("label", _hoisted_60, _toDisplayString(_unref(t)('calendar.label.add.form.date')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("label", _hoisted_62, _toDisplayString(_unref(format)(_ctx.selectedDate, _unref(DateFormat).FRONT_LONG)), 1)
                      ]),
                      (!appointmentRequest.value.isPatientWithoutAppointment)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("label", _hoisted_64, _toDisplayString(_unref(t)('calendar.label.add.form.time')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("label", _hoisted_66, _toDisplayString(_unref(format)(_ctx.selectedDate, _unref(DateFormat).TIME_SMALL)), 1)
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])),
              (!getIsMoveAppointmentAction.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("label", _hoisted_69, [
                        _createTextVNode(_toDisplayString(_unref(t)('calendar.label.add.form.duration')), 1),
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                      ])
                    ]),
                    _createVNode(_unref(PInputNumber), {
                      modelValue: appointmentRequest.value.duration,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((appointmentRequest.value.duration) = $event)),
                      min: _unref(appointment_duration_min),
                      max: _unref(appointment_duration_max),
                      class: "col-2 w-full",
                      size: "small",
                      showButtons: "",
                      disabled: !currentAppointmentType.value
                    }, null, 8, ["modelValue", "min", "max", "disabled"])
                  ]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createElementVNode("label", _hoisted_71, _toDisplayString(warningMessage.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("label", _hoisted_74, _toDisplayString(_unref(t)('calendar.label.add.form.comment')), 1)
                ]),
                _createVNode(_unref(Textarea), {
                  modelValue: appointmentRequest.value.comment,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((appointmentRequest.value.comment) = $event)),
                  invalid: appointmentRequest.value.comment?.length > 255,
                  size: "small",
                  rows: "4",
                  class: "w-full resize-none",
                  autofocus: "",
                  ref_key: "textAreaRef",
                  ref: textAreaRef
                }, null, 8, ["modelValue", "invalid"])
              ]),
              (appointmentRequest.value.comment?.length > 255)
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createElementVNode("label", _hoisted_76, _toDisplayString(_unref(t)('calendar.label.message.error.commentLength')), 1)
                  ]))
                : _createCommentVNode("", true),
              (getCurrentEvent.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    (getCurrentEvent.value.extendedProps.created)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("label", _hoisted_80, _toDisplayString(_unref(t)('calendar.label.add.form.created')), 1)
                          ]),
                          (getCurrentEvent.value.extendedProps.createdBy)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_81, _toDisplayString(_unref(t)('calendar.label.add.form.createdAtBy', {'date': _unref(formatUTCDateTimeToDate)(getCurrentEvent.value.extendedProps.created), 'time': _unref(formatUTCDateTimeToTime)(getCurrentEvent.value.extendedProps.created), 'author': getCurrentEvent.value.extendedProps.createdBy})), 1))
                            : (_openBlock(), _createElementBlock("label", _hoisted_82, _toDisplayString(_unref(t)('calendar.label.add.form.createdAt', {'date': _unref(formatUTCDateTimeToDate)(getCurrentEvent.value.extendedProps.created), 'time': _unref(formatUTCDateTimeToTime)(getCurrentEvent.value.extendedProps.created)})), 1))
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(isToday)(new Date(appointmentRequest.value.date)))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                          _createVNode(EsWaitingRoomSelector, {
                            class: "w-full",
                            roomName: appointmentRequest.value.location?.customRoomName ?? '',
                            onSelectRoomEvent: _cache[23] || (_cache[23] = ($event: any) => (setAppointmentLocation($event))),
                            "from-agenda": true
                          }, null, 8, ["roomName"])
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(isToday)(new Date(appointmentRequest.value.date)) && (appointmentRequest.value.location || getCurrentEvent.value.extendedProps.arrivalTime))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("label", _hoisted_86, _toDisplayString(_unref(t)('calendar.appointment.action.patientStatus')), 1)
                          ]),
                          _createVNode(_unref(SelectButton), {
                            modelValue: currentPatientStatus.value,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((currentPatientStatus).value = $event)),
                            options: patientStatus.value,
                            optionLabel: "optionLabel",
                            dataKey: "optionValue",
                            size: "small",
                            class: "w-full"
                          }, {
                            option: _withCtx((slotProps) => [
                              _createElementVNode("img", {
                                src: _unref(SharedService).getIcon(slotProps.option.icon, false, 'shareIcons'),
                                class: _normalizeClass(currentPatientStatus.value?.optionValue === slotProps.option.optionValue  ? 'img-white' : 'img-grey')
                              }, null, 10, _hoisted_87),
                              _createElementVNode("p", {
                                class: _normalizeClass({ 'txt-white': currentPatientStatus.value?.optionValue === slotProps.option.optionValue })
                              }, _toDisplayString(slotProps.option.optionLabel), 3)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options"])
                        ]))
                      : _createCommentVNode("", true),
                    (getCurrentEvent.value.extendedProps.arrivalTime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("label", _hoisted_90, _toDisplayString(_unref(t)('calendar.label.add.form.arrival')), 1)
                          ]),
                          _createElementVNode("label", _hoisted_91, _toDisplayString(_unref(formatUTCDateTimeToTime)(getCurrentEvent.value.extendedProps.arrivalTime)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (getCurrentEvent.value.extendedProps.departureTime)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("label", _hoisted_94, _toDisplayString(_unref(t)('calendar.label.add.form.departure')), 1)
                          ]),
                          _createElementVNode("label", _hoisted_95, _toDisplayString(_unref(formatUTCDateTimeToTime)(getCurrentEvent.value.extendedProps.departureTime)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_es_modal_footer, {
              onModalCancel: closeFormModal,
              "confirm-modal-method": async () => await confirmFormModal(),
              "confirm-disabled": !validForm()
            }, null, 8, ["confirm-modal-method", "confirm-disabled"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})